import { useTranslation } from 'react-i18next'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { XMarkIcon } from '@heroicons/react/24/outline'
import '../scss/modal.scss'

const FieldArrayConfirmModal = ({
    show,
    setShow,
    data,
    closeButtonLabel = 'btnnames.close',
    confirmButtonLabel = 'btnnames.confirm',
    hideConfirmButton = false,
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            show={show}
            onHide={() => {
                setShow(false)
            }}
            size="md"
            centered
            className="edition_modal"
            backdropClassName="edition_modal_backdrop"
        >
            <div className="pp-header">
                <div className="d-flex justify-content-end align-items-center">
                    <span
                        className="close-btn-pp-add"
                        onClick={() => {
                            setShow(false)
                        }}
                    >
                        <XMarkIcon
                            style={{
                                width: 20,
                                height: 20,
                            }}
                        />
                    </span>
                </div>
            </div>
            <div className="pp-content">
                <h2 className="pp-modal-title">
                    <>{t(data.title)}</>
                </h2>
                <div className="pp-modal-desc">{t(data.desc)}</div>
            </div>
            <div className="pp-footer">
                <div className="pp-hr"></div>
                <Row className="pp-footer-btn">
                    <Col className={hideConfirmButton ? "d-flex justify-content-center align-items-end" : "d-flex justify-start-end align-items-end"}>
                        <Button
                            style={{ width: 109, height: 30 }}
                            className="close-btn"
                            variant="secondary"
                            onClick={() => {
                                setShow(false)
                            }}
                        >
                            {t(closeButtonLabel)}
                        </Button>
                    </Col>
                    {!hideConfirmButton && (
                        <Col className="d-flex justify-content-end align-items-end">
                            <Button
                                style={{ width: 109, height: 30 }}
                                className="green-gradient-btn"
                                onClick={data.callBack}
                                type="submit"
                            >
                                {t(confirmButtonLabel)}
                            </Button>
                        </Col>
                    )}
                </Row>
            </div>
        </Modal>
    )
}

export default FieldArrayConfirmModal
